import {
    takeLatest,
} from 'redux-saga/effects';

import { setCookie } from 'helpers/CookiesHelpers';

import {
    SET_COOKIE_TIMER,
} from '../reduxModules/ConsentManagementPlatform';

// The duration of the consent validity is set to 13 months
import { CONSENT_VALIDITY_DURATION } from './initCmpAppSaga';

export function callAction() {
    // Set the timer to 13 months
    const endDate = Math.floor(Date.now() / 1000) + (60 * 60 * 24 * 30 * 13);
    try {
        window.localStorage.setItem('ypCmpTimer', endDate);
    } catch (firstError) {
        // Local storage is disabled/unavailable
        try {
            setCookie('ypCmpTimer', endDate, CONSENT_VALIDITY_DURATION);
        } catch (secondError) {
            // Cookie storage is disabled/unavailable
        }
    }
}

export function* watch() {
    yield takeLatest(SET_COOKIE_TIMER, callAction);
}
